export const APP_IDENTIFIER = 'jira-business.project-create-importer-upload-flow';

export const CSV_FILE_UPLOAD_TYPE = 'text/csv';
export const CSV_MAX_SIZE_BYTES = 500 * 1000000; // 500Mb

export const IMPORT_URL_SUFFIX = '/secure/admin/ExternalImport1.jspa';
export const NEW_EXTERNAL_IMPORT_URL = '/jira/settings/system/external-import';
export const LEARN_NEW_IMPORT_EXPERIENCE =
	'https://support.atlassian.com/jira-software-cloud/docs/import-data-to-a-software-project-using-a-csv-file/';
export const PROJECT_ROUTE_PREFIX = '/browse';

export const DEFAULT_PROJECT_CREATE_ROUTE = '/jira/create-project';

export const MONDAY_IMPORT_APP_DOWNLOAD_URL =
	'https://auth.monday.com/oauth2/authorize?client_id=64f3709a529f71593977b890275a2c07&response_type=install';

export const LEARN_MORE_LINK =
	'https://support.atlassian.com/jira-work-management/docs/import-data-into-jira-work-management-using-a-csv-file/';

export const LEARN_MORE_LINK_JSW =
	'https://support.atlassian.com/jira-software-cloud/docs/import-data-to-a-software-project-using-a-csv-file/';

export const CSV_MAPPING_SUPPORT_LINK =
	'https://support.atlassian.com/jira-work-management/docs/map-data-from-a-csv-file/';

export const SIMPLE_DATE_FORMAT_LINK =
	'https://docs.oracle.com/javase/1.5.0/docs/api/java/text/SimpleDateFormat.html';

export const LEARN_MORE_ABOUT_OTHER_TOOLS_LINK =
	'https://support.atlassian.com/jira-work-management/docs/import-data-from-other-tools-into-jira-work-management/';
export const ASANA_LEARN_MORE_ABOUT_PROJECT_SETUP =
	'https://support.atlassian.com/jira-work-management/docs/import-data-directly-from-asana-into-jira-work-management/#Structure-of-your-Asana-project-in-Jira-Work-Management';
export const ASANA_LEARN_MORE_ABOUT_PROJECT_SETUP_SOFTWARE =
	'https://support.atlassian.com/jira-software-cloud/docs/import-data-directly-from-asana-into-jira/';
export const ASANA_LEARN_MORE_ABOUT_FIELDS_MAPPING =
	'https://support.atlassian.com/jira-work-management/docs/import-data-directly-from-asana-into-jira-work-management/';
export const ASANA_LEARN_MORE_ABOUT_FIELDS_MAPPING_SOFTWARE =
	'https://support.atlassian.com/jira-software-cloud/docs/import-data-directly-from-asana-into-jira/';
export const LEARN_MORE_ABOUT_TIMELINE =
	'https://support.atlassian.com/jira-work-management/docs/what-is-the-timeline-view-and-how-do-i-use-it/';
export const LEARN_MORE_ABOUT_ISSUES =
	'https://support.atlassian.com/jira-work-management/docs/create-and-work-with-issues/';
export const LEARN_MORE_ABOUT_ISSUES_SOFTWARE =
	'https://support.atlassian.com/jira-software-cloud/docs/import-data-directly-from-asana-into-jira/';

export const MONDAY_LEARN_MORE_ABOUT_PROJECT_SETUP =
	'https://support.atlassian.com/jira-work-management/docs/import-data-directly-from-monday-into-jira-work-management/';
export const MONDAY_LEARN_MORE_ABOUT_FIELDS_MAPPING =
	'https://support.atlassian.com/jira-work-management/docs/import-data-directly-from-monday-into-jira-work-management/';
export const LEARN_MORE_ABOUT_PROJECT_HIERARCHY =
	'https://support.atlassian.com/jira-work-management/docs/create-and-work-with-issues/';
export const LEARN_MORE_ABOUT_GENERATE_MONDAY_API_TOKEN =
	'https://developer.monday.com/api-reference/docs/authentication#admin-tab';

export const JIRA_LEARN_MORE_ABOUT_PROJECT_SETUP =
	'https://support.atlassian.com/jira-work-management/docs/import-data-from-jira-software-to-jira-work-management/';
export const JIRA_FIELD_MAPPING =
	'https://support.atlassian.com/jira-work-management/docs/import-data-from-jira-software-to-jira-work-management/';

export const JIRA_BUSINESS_LEARN_MORE_ABOUT_IMPORTING =
	'https://support.atlassian.com/jira-work-management/docs/import-data-from-a-business-project-to-a-software-project/';
export const JIRA_BUSINESS_LEARN_MORE_ABOUT_PROJECT_MAPPING =
	'https://support.atlassian.com/jira-work-management/docs/import-data-from-a-business-project-to-a-software-project/#Edit-fields';
export const JIRA_BUSINESS_LEARN_MORE_ABOUT_UNSUPPORTED_FIELDS =
	'https://support.atlassian.com/jira-work-management/docs/import-data-from-a-business-project-to-a-software-project/#Unsupported-business-project-field-types';

export const CLICKUP_LEARN_MORE_ABOUT_PROJECT_SETUP =
	'https://support.atlassian.com/jira-work-management/docs/import-data-directly-from-clickup-into-jira-work-management/';
export const CLICKUP_LEARN_MORE_ABOUT_FIELDS_MAPPING =
	'https://support.atlassian.com/jira-work-management/docs/import-data-directly-from-clickup-into-jira-work-management/';
export const CLICKUP_LEARN_MORE_ABOUT_PROJECT_HIERARCHY =
	'https://support.atlassian.com/jira-work-management/docs/create-and-work-with-issues/';
export const CLICK_UP_RATE_LIMIT =
	'https://support.atlassian.com/jira-work-management/docs/import-data-directly-from-clickup-into-jira-work-management/';
export const CLICKUP_MULTI_LIST_INFO =
	'https://support.atlassian.com/jira-work-management/docs/import-data-directly-from-clickup-into-jira-work-management/#ClickUp-import-times-and-rate-limit';
export const CLICKUP_LEARN_MORE_ABOUT_STATUS_MAPPING =
	'https://support.atlassian.com/jira-work-management/docs/import-data-directly-from-clickup-into-jira-work-management/#Customize-your-statuses';

export const CONTACT_ADMIN_LINK = '/secure/ContactAdministrators!default.jspa';

export const UNAVAILABLE_TOOLS = 'unavailable_tools';
export const REQUEST_OTHER_TOOLS = 'request_other_tools';
export const CHANGE_TEMPLATE_MODAL = 'change_template_modal';
export const DEBOUNCE_DELAY = 500;

export const PROJECT_CREATE_IMPORTER_SEEN_IT_FLAG = 'jwm.project-create-importer';

export const CONTACT_SUPPORT_URL =
	'https://support.atlassian.com/contact/#/?inquiry_category=technical_issues&is_cloud=true&product_key=jira-work-management&support_type=customer';

export const TROUBLESHOOT_PAGE_URL =
	'https://support.atlassian.com/jira-work-management/docs/fix-errors-in-a-business-project-import/';
export const TROUBLESHOOT_PAGE_URL_SOFTWARE =
	'https://support.atlassian.com/jira-software-cloud/docs/fix-errors-in-a-project-import/';

export const JIRA_WAC_LINK = 'https://www.atlassian.com/software/jira';
export const JSM_WAC_LINK = 'https://www.atlassian.com/software/jira/service-management';
export const MAPPING_FIELDS_INFO_LINK =
	'https://support.atlassian.com/jira-work-management/docs/map-data-from-a-csv-file/';

export const COLUMN_HEADER_TEST_ID_PREFIX =
	'project-create-importer-upload-flow.ui.mapping-screen.mapping-table.column-header';
export const SEARCH_TEXTFIELD_TEST_ID =
	'project-create-importer-upload-flow.common.ui.search-bar.textfield';
export const FIELDS_DROPDOWN_TEST_ID_PREFIX =
	'project-create-importer-upload-flow.ui.mapping-screen.fields-dropdown';
export const OTHER_TOOLS_REQUEST_MODAL_TEST_ID =
	'project-create-importer-upload-flow.ui.upload-screen.import-from-other-tools.other-tools-request-modal.modal';
export const OTHER_TOOLS_REQUEST_MODAL_CLOSE_ICON_TEST_ID =
	'project-create-importer-upload-flow.ui.upload-screen.import-from-other-tools.other-tools-request-modal.close-icon';
export const PRE_OAUTH_MODAL_TEST_ID =
	'project-create-importer-upload-flow.ui.upload-screen.import-from-other-tools.pre-oauth-modal';
export const FILE_ENCODING_DROPDOWN_TESTID_PREFIX =
	'project-create-importer-upload-flow.ui.upload-screen.upload-csv-dropzone.upload-advanced-options.file-encoding-dropdown';
export const THIRD_PARTY_FIELD_SELECTOR_TEST_ID_PREFIX =
	'project-create-importer-upload-flow.ui.third-party-review-screen.fields-mapping.fields-mapping-content.field-selector';
export const THIRD_PARTY_HIERARCHY_SELECTOR_TEST_ID_PREFIX =
	'project-create-importer-upload-flow.ui.third-party-review-screen.project-hierarchy.item-selector';
export const REVIEW_SCREEN_CARD_TEST_ID =
	'project-create-importer-upload-flow.ui.third-party-review-screen.review-tiles.card.wrapper';

export const SELECT_ID_PREFIX = 'react-select';
export const ATLASKIT_PORTAL_CLASSNAME = 'atlaskit-portal';
export const ENTITY_DROPDOWN_ID_PREFIX = 'entityDropdown';
export const PROJECT_TYPE_DROPDOWN_ID = 'DropdownProjectType';
export const PROJECT_MANAGEMENT_TYPE_DROPDOWN_ID = 'DropdownProjectManagementType';
export const PROJECT_TEMPLATE_DROPDOWN_ID = 'DropdownProjectTemplate';

export const ESCAPE_WHITELIST_TESTIDS = [
	COLUMN_HEADER_TEST_ID_PREFIX,
	FIELDS_DROPDOWN_TEST_ID_PREFIX,
	OTHER_TOOLS_REQUEST_MODAL_TEST_ID,
	PRE_OAUTH_MODAL_TEST_ID,
	FILE_ENCODING_DROPDOWN_TESTID_PREFIX,
	SEARCH_TEXTFIELD_TEST_ID,
	THIRD_PARTY_FIELD_SELECTOR_TEST_ID_PREFIX,
	THIRD_PARTY_HIERARCHY_SELECTOR_TEST_ID_PREFIX,
];

export const ESCAPE_WHITELIST_IDS = [
	SELECT_ID_PREFIX,
	ENTITY_DROPDOWN_ID_PREFIX,
	PROJECT_TYPE_DROPDOWN_ID,
	PROJECT_MANAGEMENT_TYPE_DROPDOWN_ID,
	PROJECT_TEMPLATE_DROPDOWN_ID,
];

export const MAPPING_FIELD_UPDATE_SUCCESS_FLAG_ID = 'mapping-field-update-success-flag';
export const MAPPING_HIERARCHY_UPDATE_SUCCESS_FLAG_ID = 'mapping-hierarchy-update-success-flag';
export const MAPPING_STATUS_UPDATE_SUCCESS_FLAG_ID = 'mapping-status-update-success-flag';

export const OAUTH_UNSUCCESS_FLAG_ID = 'import-3p-oauth-unsuccess-flag';

export const DEFAULT_ITEM_TYPE = 'ITEM';
export const DEFAULT_SUBITEM_TYPE = 'SUBITEM';

export const CLICKUP_MAX_LISTS = 10;

export const DEFAULT_TABLE_ROWS_PER_PAGE = 8;

export const STRUCTURE_CSV_LINK =
	'https://support.atlassian.com/jira-software-cloud/docs/prepare-a-csv-file-for-import/';
export const MAPPING_GUIDE_SOFTWARE =
	'https://support.atlassian.com/jira-software-cloud/docs/mapping-csv-data-to-jira-fields/';
export const MAPPING_GUIDE_BUSINESS =
	'https://support.atlassian.com/jira-work-management/docs/map-data-from-a-csv-file/';
export const WHAT_IS_AN_ISSUE_LINK =
	'https://support.atlassian.com/jira-software-cloud/docs/what-is-an-issue/';
